import { TimeScheduleTemplate } from "components/events/ConditionDetail/TimeScheduleTemplate";
import { RangeOfRecurrenceTemplate } from "components/modals/RangeOfRecurrenceTemplate";
import "assets/css/event.css";
import { getDefaultRecurrenceEndTime } from "utils/eventFunctions";

const Daily = ({
    priTime,
    setPriTime,
    secTime,
    setSecTime,
    timeList,
    setTimeList,
    timeRangeList,
    setTimeRangeList,
    selectedInterval,
    setSelectedInterval,
    duration,
    setDuration,
    selectedTimeOption,
    setSelectedTimeOption,
    errorType,
    setErrorType,
    day,
    setRecurrenceRange,
    recurrenceRange,
    renderErrorMsg,
    recurrenceErrorMsg,
    updateRecurrenceErrorMsg,
    clearParentError,
    isGatewayLevel,
}: any) => {
    const setDailyRecurrenceRange = (recurrence: any) => {
        const { daily } = recurrence;
        if (
            daily.endDateEnabled &&
            daily.endDateEnabled !== recurrenceRange["daily"].endDateEnabled
        ) {
            setRecurrenceRange({
                ...recurrence,
                daily: {
                    ...recurrence["daily"],
                    endDate: getDefaultRecurrenceEndTime({
                        startTime: recurrence["daily"].startDate,
                        amount: 1,
                        unit: "months",
                    }),
                },
            });
        } else {
            setRecurrenceRange(recurrence);
        }
    };

    return (
        <>
            <div className="form-box mb-3">
                <h5 className="mb-4">Time Schedule</h5>
                <TimeScheduleTemplate
                    priTime={priTime}
                    setPriTime={setPriTime}
                    secTime={secTime}
                    setSecTime={setSecTime}
                    selectedTimeOption={selectedTimeOption}
                    setSelectedTimeOption={setSelectedTimeOption}
                    selectedInterval={selectedInterval}
                    setSelectedInterval={setSelectedInterval}
                    duration={duration}
                    setDuration={setDuration}
                    timeList={timeList}
                    setTimeList={setTimeList}
                    timeRangeList={timeRangeList}
                    setTimeRangeList={setTimeRangeList}
                    errorType={errorType}
                    setErrorType={setErrorType}
                    day={day}
                    renderErrorMsg={renderErrorMsg}
                    recurrence={"daily"}
                    onValidTimeChange={clearParentError}
                    isGatewayLevel={isGatewayLevel}
                />
            </div>
            <RangeOfRecurrenceTemplate
                recurrence={"daily"}
                recurrenceRange={recurrenceRange}
                setRecurrenceRange={setDailyRecurrenceRange}
                renderErrorMsg={renderErrorMsg}
                recurrenceErrorMsg={recurrenceErrorMsg}
                updateRecurrenceErrorMsg={updateRecurrenceErrorMsg}
            />
        </>
    );
};

export default Daily;
